function formatDuration(durationMs) {
    const seconds = Math.floor(durationMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    const remainingHours = hours % 24;
    const remainingMinutes = minutes % 60;
    const remainingSeconds = seconds % 60;

    let formattedDuration = '';

    if (days > 0) {
        formattedDuration += `${days}d `;
    }
    if (remainingHours > 0 || days > 0) {
        formattedDuration += `${remainingHours}h `;
    }
    if (remainingMinutes > 0 || remainingHours > 0 || days > 0) {
        formattedDuration += `${remainingMinutes}m `;
    }
    formattedDuration += `${remainingSeconds}s`;

    return formattedDuration.trim();
}

function formatMinutesToTimeExtended(minutes) {
  const totalMinutes = minutes % (24 * 60); // Handle minutes beyond 24 hours
  const hrs = Math.floor(totalMinutes / 60);
  const mins = Math.round(totalMinutes % 60);
  const ampm = hrs >= 12 ? 'PM' : 'AM';
  const displayHours = hrs % 12 || 12;
  return `${displayHours}:${mins.toString().padStart(2, '0')} ${ampm}`;
}

function formatAMPM(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // Convert 0 to 12
  minutes = minutes < 10 ? '0' + minutes : minutes;

  return `${hours}:${minutes} ${ampm}`;
}

function calculateEventDays(adjustedEvents) {
  
  const daysOfWeek = [
    "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
  ];
  
  const eventDays = adjustedEvents.map(date => {
    const day = daysOfWeek[date.getDay()];    
    return day;
  });
  
  return eventDays;
}

function calculateExponentialMovingAverage(data, smoothingFactor) {
  const result = [];
  const dayInMinutes = 1440;
  let emaY = data[0].y; // Start with the first data point

  for (let i = 0; i < data.length; i++) {
    let currentY = data[i].y;

    // Adjust times that cross midnight
    if (Math.abs(currentY - emaY) > dayInMinutes / 2) {
      if (currentY < dayInMinutes / 2) {
        currentY += dayInMinutes;
      } else {
        currentY -= dayInMinutes;
      }
    }

    // Calculate EMA
    emaY = smoothingFactor * currentY + (1 - smoothingFactor) * emaY;

    // Adjust back if necessary
    if (emaY >= dayInMinutes) {
      emaY -= dayInMinutes;
    } else if (emaY < 0) {
      emaY += dayInMinutes;
    }

    result.push({
      x: data[i].x,
      y: emaY,
      label: formatMinutesToTimeExtended(emaY)
    });
  }

  return result;
}




function summarizeEventDays(eventDays) {
  const summary = {
    Sunday: 0,
    Monday: 0,
    Tuesday: 0,
    Wednesday: 0,
    Thursday: 0,
    Friday: 0,
    Saturday: 0,
  };

  eventDays.forEach((day) => {
    summary[day]++;
  });

  return summary;
}

function analyzeRegularUsage() {
  const eventDays = calculateEventDays();
  const summary = summarizeEventDays(eventDays);
  const analysisResult = calculateUsageStatistics(summary);
  return analysisResult;
}

function calculateUsageStatistics(summary) {
  const daysOfWeek = Object.keys(summary);
  const usageCounts = Object.values(summary);

  const averageUsage = usageCounts.reduce((a, b) => a + b, 0) / 7;
  const sortedCounts = [...usageCounts].sort((a, b) => a - b);
  const medianUsage = sortedCounts[3];

  const squareDiffs = usageCounts.map(count => Math.pow(count - averageUsage, 2));
  const avgSquareDiff = squareDiffs.reduce((a, b) => a + b, 0) / 7;
  const standardDeviation = Math.sqrt(avgSquareDiff);

  const consistencyScore = (averageUsage / standardDeviation) * 100;

  const mostActiveDay = daysOfWeek[usageCounts.indexOf(Math.max(...usageCounts))];
  const leastActiveDay = daysOfWeek[usageCounts.indexOf(Math.min(...usageCounts))];

  return {
    averageUsage,
    medianUsage,
    standardDeviation,
    consistencyScore,
    mostActiveDay,
    leastActiveDay,
    dailyUsage: summary
  };
}

function calculateDaysSinceLastUse() {
  console.log("Starting calculateDaysSinceLastUse with window.bedtimeData");

  if (!window.bedtimeData) {
    console.error("window.bedtimeData is not available");
    return null;
  }

  let lastUse = null;

  for (const dayEvents of Object.values(window.bedtimeData)) {
    for (const event of dayEvents) {
      if (event.wakeUpTime && event.wakeUpTime !== "N/A") {
        const wakeUpDate = new Date(event.wakeUpTime);
        if (!lastUse || wakeUpDate > lastUse) lastUse = wakeUpDate;
      }
      if (event.bedTime && event.bedTime !== "N/A") {
        const bedTimeDate = new Date(event.bedTime);
        if (!lastUse || bedTimeDate > lastUse) lastUse = bedTimeDate;
      }
    }
  }

  if (!lastUse) {
    console.error("No valid usage data found");
    return null;
  }

  const currentDate = new Date();
  const daysSinceLastUse = Math.floor((currentDate - lastUse) / (1000 * 60 * 60 * 24));

  return daysSinceLastUse;
}

function calculateBedtimeTargetDistance(bedtimeAMPM) {

  
  if (!window.bedtimeData) {
    console.error("window.bedtimeData is not available");
    return null;
  }

  const targetBedtime = parseBedtime(bedtimeAMPM); // Assume this is set elsewhere


  let totalDistance = 0;
  let count = 0;
  const dayDistances = {
    Sunday: [], Monday: [], Tuesday: [], Wednesday: [], Thursday: [], Friday: [], Saturday: []
  };

  for (const [day, events] of Object.entries(window.bedtimeData)) {
    events.forEach(({ wakeUpTime, bedTime }) => {
      if (bedTime && bedTime !== "N/A") {
        const distance = calculateTimeDifference(new Date(bedTime), targetBedtime);

        
        totalDistance += Math.abs(distance);
        count++;
        dayDistances[day].push(distance);
      }
      // We don't use wake-up times for bedtime target distance calculation
    });
  }


  const averageDistance = count > 0 ? totalDistance / count : 0;
  const averageDayDistances = {};

  for (const [day, distances] of Object.entries(dayDistances)) {
    if (distances.length > 0) {
      const avg = distances.reduce((a, b) => a + b, 0) / distances.length;
      averageDayDistances[day] = Math.round(avg);
    }
  }


  return {
    averageDistance: Math.round(averageDistance),
    averageDayDistances
  };
}

function calculateUsageMetrics() {
  

  if (!window.bedtimeData) {
    console.error("window.bedtimeData is not available");
    return null;
  }

  let firstUse = null;
  let lastUse = null;
  let numberOfEvents = 0;

  for (const dayEvents of Object.values(window.bedtimeData)) {
  for (const event of dayEvents) {
    let eventCounted = false; // Flag to ensure only one event is counted per record

    // Check for wake-up time
    if (event.wakeUpTime && event.wakeUpTime !== "N/A") {
      const wakeUpDate = new Date(event.wakeUpTime);
      
      if (!firstUse || wakeUpDate < firstUse) firstUse = wakeUpDate;
      if (!lastUse || wakeUpDate > lastUse) lastUse = wakeUpDate;
      eventCounted = true; // Mark this event as counted
    }

    // Check for bedtime (if it hasn't been counted already)
    if (event.bedTime && event.bedTime !== "N/A") {
      const bedTimeDate = new Date(event.bedTime);
      if (!firstUse || bedTimeDate < firstUse) firstUse = bedTimeDate;
      if (!lastUse || bedTimeDate > lastUse) lastUse = bedTimeDate;
      if (!eventCounted) { // Only count if not already counted by wake-up time
        eventCounted = true;
      }
    }

    // If either wake-up time or bedtime was counted, increment number of events
    if (eventCounted) {
      numberOfEvents++;
    }
  }
}

  if (!firstUse || !lastUse) {
    console.error("No valid usage data found");
    return null;
  }
  const currentDate = new Date();
  const daysSinceFirstUse = Math.floor((currentDate - firstUse) / (1000 * 60 * 60 * 24));

  const daysSinceLastUse = Math.floor((currentDate - lastUse) / (1000 * 60 * 60 * 24));

  const rawDaysBetween = Math.floor((lastUse - firstUse) / (1000 * 60 * 60 * 24));
  const daysBetweenFirstAndLastUse = rawDaysBetween + 1;



  return {
    firstUse,
    lastUse,
    daysSinceFirstUse,
    daysSinceLastUse,
    daysBetweenFirstAndLastUse,
    numberOfEvents
  };
}

function parseBedtime(bedtime) {
  if (!bedtime || typeof bedtime !== 'string') {
    console.error('Invalid bedtime value:', bedtime);
    return new Date(); // Return current date as fallback
  }

  // Clean up the bedtime string
  const cleanedBedtime = bedtime
    .replace(/\u202F/g, ' ')  // Replace non-breaking space with regular space
    .replace(/\s+/g, ' ')     // Replace multiple spaces with single space
    .trim();                  // Remove leading/trailing spaces

  const parts = cleanedBedtime.split(' ');
  if (parts.length !== 2) {
    console.error('Invalid bedtime format:', bedtime);
    return new Date(); // Return current date as fallback
  }

  const [time, period] = parts;
  const [hours, minutes] = time.split(':').map(Number);

  if (isNaN(hours) || isNaN(minutes)) {
    console.error('Invalid time format in bedtime:', bedtime);
    return new Date(); // Return current date as fallback
  }

  const date = new Date();
  const upperPeriod = period.toUpperCase();
  
  if (!['AM', 'PM'].includes(upperPeriod)) {
    console.error('Invalid period in bedtime:', bedtime);
    return date; // Return current date as fallback
  }

  date.setHours(
    upperPeriod === 'PM' && hours !== 12 ? hours + 12 : hours,
    minutes,
    0,
    0
  );

  return date;
}

function calculateTimeDifference(time1, time2) {
  const diff = (time1.getHours() * 60 + time1.getMinutes()) - (time2.getHours() * 60 + time2.getMinutes());
  if (diff > 720) return diff - 1440;
  if (diff < -720) return diff + 1440;
  return diff;
}

function analyzeWakeUpTimes() {
  

  if (!window.bedtimeData) {
    console.error("window.bedtimeData is not available");
    return null;
  }

  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const wakeUpTimes = {
    Sunday: [], Monday: [], Tuesday: [], Wednesday: [], Thursday: [], Friday: [], Saturday: []
  };
  let allWakeUpTimes = [];

  // Collect wake-up times
  for (const [day, events] of Object.entries(window.bedtimeData)) {
    events.forEach(({ wakeUpTime }) => {
      if (wakeUpTime && wakeUpTime !== "N/A") {
        const date = new Date(wakeUpTime);
        const minutes = date.getHours() * 60 + date.getMinutes();
        wakeUpTimes[day].push(minutes);
        allWakeUpTimes.push(minutes);
      }
    });
  }

  // Calculate averages for each day
  const averagesByDay = {};
  for (const day of daysOfWeek) {
    if (wakeUpTimes[day].length > 0) {
      const avg = wakeUpTimes[day].reduce((a, b) => a + b, 0) / wakeUpTimes[day].length;
      averagesByDay[day] = formatMinutesToTime(Math.round(avg));
    } else {
      averagesByDay[day] = "N/A";
    }
  }

  // Calculate overall average
  const overallAverage = allWakeUpTimes.length > 0
    ? formatMinutesToTime(Math.round(allWakeUpTimes.reduce((a, b) => a + b, 0) / allWakeUpTimes.length))
    : "N/A";

  // Calculate standard deviation
  const avgMinutes = allWakeUpTimes.reduce((a, b) => a + b, 0) / allWakeUpTimes.length;
  const squaredDiffs = allWakeUpTimes.map(time => Math.pow(time - avgMinutes, 2));
  const avgSquaredDiff = squaredDiffs.reduce((a, b) => a + b, 0) / allWakeUpTimes.length;
  const standardDeviation = Math.sqrt(avgSquaredDiff);

  // Convert standard deviation to hours and minutes
  const stdDevHours = Math.floor(standardDeviation / 60);
  const stdDevMinutes = Math.round(standardDeviation % 60);


  return {
    averagesByDay,
    overallAverage,
    standardDeviation: `${stdDevHours}h ${stdDevMinutes}m`
  };


  function formatMinutesToTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    return `${formattedHours}:${mins.toString().padStart(2, '0')} ${period}`;
  }
}

// Add this function to the calculation-score.js file
function analyzeSleepPatterns(targetBedtimeAMPM) {
  if (!window.bedtimeData) {
    console.error("window.bedtimeData is not available");
    return null;
  }

  const targetBedtime = parseBedtime(targetBedtimeAMPM);
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const wakeUpTimes = {
    Sunday: [], Monday: [], Tuesday: [], Wednesday: [], Thursday: [], Friday: [], Saturday: []
  };
  const bedTimeDistances = {
    Sunday: [], Monday: [], Tuesday: [], Wednesday: [], Thursday: [], Friday: [], Saturday: []
  };

  // Collect wake-up times and bedTime distances from target bedtime
  const allWakeUpTimes = [];
  const allBedTimeDistances = [];

  for (const [day, events] of Object.entries(window.bedtimeData)) {
    events.forEach(({ wakeUpTime, bedTime }) => {
      if (wakeUpTime && wakeUpTime !== "N/A") {
        const date = new Date(wakeUpTime);
        const wakeUpMinutes = date.getHours() * 60 + date.getMinutes();
        wakeUpTimes[day].push(wakeUpMinutes);
        allWakeUpTimes.push(wakeUpMinutes);
      }
      if (bedTime && bedTime !== "N/A") {
        const distance = calculateTimeDifference(new Date(bedTime), targetBedtime);
        bedTimeDistances[day].push(distance);
        allBedTimeDistances.push(distance);
      }
    });
  }



  // Calculate standard deviations for each day
  const wakeUpStandardDeviations = [];
  const bedTimeStandardDeviations = [];

  for (const day of daysOfWeek) {
    if (wakeUpTimes[day].length > 1) {
      const standardDeviationWakeUp = calculateStandardDeviation(wakeUpTimes[day]);
      wakeUpStandardDeviations.push(standardDeviationWakeUp);

    }
    if (bedTimeDistances[day].length > 1) {
      const standardDeviationBedTime = calculateStandardDeviation(bedTimeDistances[day]);
      bedTimeStandardDeviations.push(standardDeviationBedTime);

    }
  }

  // Calculate the average of the standard deviations across all days
  const averageWakeUpStandardDeviation = wakeUpStandardDeviations.reduce((a, b) => a + b, 0) / wakeUpStandardDeviations.length;
  const averageBedTimeStandardDeviation = bedTimeStandardDeviations.reduce((a, b) => a + b, 0) / bedTimeStandardDeviations.length;



  // Calculate overall standard deviation for all wake-up times and bedtimes
  const overallStandardDeviationWakeUp = allWakeUpTimes.length > 1 ? calculateStandardDeviation(allWakeUpTimes) : 0;
  const overallStandardDeviationBedTime = allBedTimeDistances.length > 1 ? calculateStandardDeviation(allBedTimeDistances) : 0;

  const overallAverageStandardDeviation = (overallStandardDeviationWakeUp + overallStandardDeviationBedTime) / 2;


  return {
    averageWakeUpStandardDeviation,
    averageBedTimeStandardDeviation,
    overallStandardDeviationWakeUp,
    overallStandardDeviationBedTime,
    overallAverageStandardDeviation
  };
}

function calculateStandardDeviation(values) {
  const mean = values.reduce((a, b) => a + b, 0) / values.length;
  const variance = values.reduce((acc, val) => acc + Math.pow(val - mean, 2), 0) / values.length;
  return Math.sqrt(variance);
}

function calculateFrequencyAdherence(events, frequency) {
  if (!frequency || events.length === 0) {
    console.log('No frequency provided or no events, returning null');
    return null;
  }

  const eventDates = events.map(event => new Date(event));

  // Handle Multiple Times Per Period differently
  if (frequency.fT === "Multiple Times Per") {
    const targetCount = parseInt(frequency.fV);
    const periodType = frequency.fP; // "day", "week", "month"
    
    // Group events by their periods
    const periodGroups = new Map();
    
    eventDates.forEach(date => {
      // Get the end of the period this event belongs to
      const periodEnd = getEndOfPeriod(date, periodType).toISOString();
      
      if (!periodGroups.has(periodEnd)) {
        periodGroups.set(periodEnd, 0);
      }
      periodGroups.set(periodEnd, periodGroups.get(periodEnd) + 1);
    });

    // Calculate adherence based on periods that met the target count
    let adherenceCount = 0;
    let currentStreak = 0;
    let longestStreak = 0;
    let streakStart = null;
    
    // Sort periods chronologically
    const sortedPeriods = Array.from(periodGroups.entries())
      .sort(([dateA], [dateB]) => new Date(dateA) - new Date(dateB));
    
    sortedPeriods.forEach(([periodEnd, count], index) => {
      if (count >= targetCount) {
        adherenceCount++;
        currentStreak++;
        
        if (currentStreak > longestStreak) {
          longestStreak = currentStreak;
          // Calculate streak start based on period type
          streakStart = getStartOfPeriod(new Date(periodEnd), periodType);
        }
      } else {
        currentStreak = 0;
      }
    });

    return {
      adherencePercentage: (adherenceCount / sortedPeriods.length) * 100,
      adherenceCount,
      totalExpectedEvents: sortedPeriods.length,
      currentStreak,
      longestStreak,
      streakStart
    };
  } else {
    // Original logic for other frequency types
    let adherenceCount = 0;
    let totalExpectedEvents = 0;
    let currentStreak = 0;
    let longestStreak = 0;
    let streakStart = null;

    for (let i = 0; i < eventDates.length - 1; i++) {
      const expectedNextDate = calculateNextDueDate(eventDates[i], frequency);
      const actualNextDate = eventDates[i + 1];
      
      totalExpectedEvents++;
      
      if (Math.abs(expectedNextDate - actualNextDate) < 24 * 60 * 60 * 1000) {
        adherenceCount++;
        currentStreak++;
        
        if (currentStreak > longestStreak) {
          longestStreak = currentStreak;
          streakStart = eventDates[i - currentStreak + 1];
        }
      } else {
        currentStreak = 0;
      }
    }
    
    if (currentStreak > 0) currentStreak++;
    if (longestStreak > 0) longestStreak++;
    
    return {
      adherencePercentage: (adherenceCount / totalExpectedEvents) * 100,
      adherenceCount,
      totalExpectedEvents,
      currentStreak,
      longestStreak,
      streakStart
    };
  }
}

function analyzeRoutineStartTimeConsistency(events) {
    console.log('Analyzing routine start time consistency');
    console.log('Input events:', events);

    // Group events by day
    const eventsByDay = events.reduce((acc, event) => {
        const day = event.toDateString();
        if (!acc[day]) {
            acc[day] = event;
        }
        return acc;
    }, {});

    // Get start times of first events of each day
    const startTimes = Object.values(eventsByDay).map(event => {
        const minutes = event.getHours() * 60 + event.getMinutes();
        console.log(`First event of day start time:`, { original: event, minutes });
        return minutes;
    });

    console.log('Start times in minutes:', startTimes);

    if (startTimes.length === 0) {
        return { averageStartTime: 'N/A', standardDeviation: 0, consistency: 0 };
    }

    const averageStartTime = startTimes.reduce((a, b) => a + b, 0) / startTimes.length;
    console.log('Average start time (in minutes):', averageStartTime);

    // Calculate standard deviation directly
    const squaredDiffs = startTimes.map(time => Math.pow(time - averageStartTime, 2));
    const averageSquaredDiff = squaredDiffs.reduce((a, b) => a + b, 0) / startTimes.length;
    const standardDeviation = Math.sqrt(averageSquaredDiff);

    console.log('Standard deviation:', standardDeviation);

    const consistency = Math.max(0, 100 - (standardDeviation / 60) * 100);
    console.log('Consistency score:', consistency);

    const result = {
        averageStartTime: formatMinutesToTime(Math.round(averageStartTime)),
        standardDeviation: Math.round(standardDeviation),
        consistency: consistency
    };

    console.log('Final result:', result);
    return result;
}

function analyzeRoutineDurationConsistency(eventPairs) {
    console.log('Analyzing routine duration consistency');
    console.log('Input event pairs:', eventPairs);

    const durations = eventPairs.map(pair => {
        const [startTime, endTime] = pair;
        const duration = endTime - startTime;
        console.log('Event duration:', duration, 'ms');
        return duration;
    });

    if (durations.length === 0) {
        console.log('No valid durations found');
        return null;
    }

    const averageDuration = durations.reduce((a, b) => a + b, 0) / durations.length;
    console.log('Average duration:', averageDuration, 'ms');

    const variance = durations.reduce((acc, duration) => {
        const diff = duration - averageDuration;
        const squaredDiff = Math.pow(diff, 2);
        return acc + squaredDiff;
    }, 0) / durations.length;

    const standardDeviation = Math.sqrt(variance);
    console.log('Standard deviation:', standardDeviation, 'ms');

    const consistencyPercentage = (standardDeviation / averageDuration) * 100;
    console.log('Consistency percentage:', consistencyPercentage, '%');

    const result = {
        averageDuration: averageDuration,
        standardDeviation: standardDeviation,
        consistencyPercentage: consistencyPercentage
    };

    console.log('Final result:', result);
    return result;
}

function analyzeMarkerStartTimeConsistency(events) {
  console.log('analyzeMarkerStartTimeConsistency - Input events:', events);

  const startTimes = events.map((event, index) => {
    const date = new Date(event);
    const minutes = date.getHours() * 60 + date.getMinutes();
    console.log(`Event ${index} start time:`, { original: event, date, minutes });
    return minutes;
  });

  console.log('Start times in minutes:', startTimes);

  const averageStartTime = startTimes.reduce((a, b) => a + b, 0) / startTimes.length;
  console.log('Average start time (in minutes):', averageStartTime);

  const variance = startTimes.reduce((acc, time) => {
    const diff = time - averageStartTime;
    const squaredDiff = Math.pow(diff, 2);
    console.log('Variance calculation:', { time, diff, squaredDiff });
    return acc + squaredDiff;
  }, 0) / startTimes.length;

  console.log('Variance:', variance);

  const standardDeviation = Math.sqrt(variance);
  console.log('Standard deviation:', standardDeviation);

  const consistency = Math.max(0, 100 - (standardDeviation / 60) * 100);
  console.log('Consistency score:', consistency);

  const result = {
    averageStartTime: formatMinutesToTime(Math.round(averageStartTime)),
    standardDeviation: Math.round(standardDeviation),
    consistency: consistency // Higher is more consistent
  };

  console.log('Final result:', result);

  return result;
}

function analyzeSleepTimesSeries() {
  if (!window.bedtimeData) {
    console.error("window.bedtimeData is not available");
    return null;
  }
  console.log('Standard bedtimeData:', window.bedtimeData);

  const wakeUpData = [];
  const bedtimeData = [];
  let earliestWakeUp = Infinity;
  let latestWakeUp = -Infinity;
  let earliestBedtime = Infinity;
  let latestBedtime = -Infinity;

  // Process each day's data
  Object.entries(window.bedtimeData).forEach(([day, events]) => {
    events.forEach(({ wakeUpTime, bedTime }) => {

      // Handle wake-up times
      if (wakeUpTime && wakeUpTime !== "N/A") {
        const date = new Date(wakeUpTime);
        const x = date.getTime();
        // Convert wake-up time to minutes since midnight
        let y = date.getHours() * 60 + date.getMinutes();
        
        // Ensure wake-up times are always represented in 0-1440 range (24 hours)
        y = y % 1440;


        wakeUpData.push({
          x: x,
          y: y,
          label: formatAMPM(date),
          originalDate: date
        });

        earliestWakeUp = Math.min(earliestWakeUp, y);
        latestWakeUp = Math.max(latestWakeUp, y);
      }

      // Handle bedtimes
      if (bedTime && bedTime !== "N/A") {
        const date = new Date(bedTime);
        const x = date.getTime();
        let y = date.getHours() * 60 + date.getMinutes();

        // Adjust late night times to appear after midnight
        // If bedtime is between 12:00 AM and 6:00 AM, add 24 hours worth of minutes
        if (y < 300) { // Before 5 AM
          y += 1440; // Add 24 hours worth of minutes          
        }


        bedtimeData.push({
          x: x,
          y: y,
          label: formatAMPM(date),
          originalDate: date
        });

        // For min/max calculations, use the adjusted time
        earliestBedtime = Math.min(earliestBedtime, y);
        latestBedtime = Math.max(latestBedtime, y);
      }
    });
  });

  // Sort data chronologically
  wakeUpData.sort((a, b) => a.x - b.x);
  bedtimeData.sort((a, b) => a.x - b.x);

  console.log('Wake-up Data after processing:', wakeUpData);
  console.log('Bedtime Data after processing:', bedtimeData);

  // Remove outliers using 2.5 standard deviations
  function removeOutliers(data) {
    console.log('Removing outliers from data:', data);

    if (data.length <= 20) {
      console.log('Data length <= 20, no outliers removed.');
      return data;
    }

    const yValues = data.map(point => point.y);
    const mean = yValues.reduce((a, b) => a + b, 0) / yValues.length;
    const squaredDiffs = yValues.map(y => Math.pow(y - mean, 2));
    const standardDeviation = Math.sqrt(squaredDiffs.reduce((a, b) => a + b, 0) / yValues.length);
    
    const threshold = 2.5 * standardDeviation;
    console.log(`Mean: ${mean}, Standard Deviation: ${standardDeviation}, Threshold: ${threshold}`);

    const filteredData = data.filter(point => Math.abs(point.y - mean) <= threshold);
    console.log('Data after outlier removal:', filteredData);

    return filteredData;
  }

  // Remove outliers and calculate trends
  const filteredWakeUpData = removeOutliers(wakeUpData);
  const filteredBedtimeData = removeOutliers(bedtimeData);

  console.log('Filtered Wake-up Data:', filteredWakeUpData);
  console.log('Filtered Bedtime Data:', filteredBedtimeData);

  const smoothingFactor = 0.1; // Adjust between 0 (less responsive) and 1 (more responsive)
  const wakeUpTrend = calculateExponentialMovingAverage(filteredWakeUpData, smoothingFactor);
  const bedtimeTrend = calculateExponentialMovingAverage(filteredBedtimeData, smoothingFactor);

  console.log('Wake-up Trend:', wakeUpTrend);
  console.log('Bedtime Trend:', bedtimeTrend);

  // Log time ranges for debugging
  console.log('Time Ranges:', {
    wakeUp: { min: earliestWakeUp, max: latestWakeUp },
    bedtime: { min: earliestBedtime, max: latestBedtime }
  });

  return {
    wakeUpData: filteredWakeUpData,
    bedtimeData: filteredBedtimeData,
    wakeUpTrend,
    bedtimeTrend,
    timeRanges: {
      wakeUp: { 
        min: Math.max(0, earliestWakeUp), 
        max: Math.min(1440, latestWakeUp)
      },
      bedtime: {
        min: Math.max(0, earliestBedtime), 
        max: Math.min(2880, latestBedtime) // Allow up to 48 hours for adjusted bedtimes
      }
    }
  };
}


function getStreakVerbiage(streak, frequency) {
  // Early return if no streak or frequency
  if (!streak || !frequency) {
    return "0 completions";
  }

  switch (frequency.fT) {
    case "Multiple Times Per":
      // For "X times per hour/day/week/month"
      return `${streak} ${frequency.fP}${streak === 1 ? '' : 's'} at target frequency`;
      
    case "Some time per period":
      // Format: "1:Week", "1:Month", "1:Year"
      const [count, period] = frequency.fP.split(':');
      return `${streak} ${period.toLowerCase()}${streak === 1 ? '' : 's'}`;
      
    case "Every Day":
      return `${streak} day${streak === 1 ? '' : 's'}`;
      
    case "Specific Days of the Week":
      return `${streak} day${streak === 1 ? '' : 's'}`;
      
    case "Specific Days of the Month":
      return `${streak} day${streak === 1 ? '' : 's'}`;
      
    case "Repeat":
      // For "Every X days"
      const days = parseInt(frequency.fV);
      return `${streak} ${days}-day period${streak === 1 ? '' : 's'}`;
      
    default:
      return `${streak} completion${streak === 1 ? '' : 's'}`;
  }
}

window.CalculationScore = {
  analyzeRegularUsage,
  analyzeWakeUpTimes,
  calculateDaysSinceLastUse,
  calculateEventDays,
  calculateUsageMetrics,
  getStreakVerbiage,
  summarizeEventDays,
  calculateBedtimeTargetDistance,
  calculateUsageStatistics,
  analyzeRoutineStartTimeConsistency,
  analyzeRoutineDurationConsistency,
  analyzeMarkerStartTimeConsistency,
  calculateFrequencyAdherence,  
  analyzeSleepPatterns,
  analyzeSleepTimesSeries
};